export const reduceFieldsToMap = (fields) =>
  fields.reduce(
    (map, field) => ({
      ...map,
      [field.dataIndex]: field,
    }),
    {}
  );
